import { render, staticRenderFns } from "./file-select.vue?vue&type=template&id=48645f46&"
import script from "./file-select.vue?vue&type=script&lang=js&"
export * from "./file-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports